import { Image } from '@aws-amplify/ui-react';
import { useState } from 'react';
import { AiOutlineCamera } from 'react-icons/ai';
import ReactModal from 'react-modal';
import { CLOUDFRONT_DOMAIN } from '../utils/Constants';
import General from '../utils/GeneralUtils';
import './ScreenshotViewer.scss';

interface ScreenshotViewerProps {
  /** CloudFront key, i.e. an S3 ARN with its prefix already stripped. */
  screenshotKey?: string | null;
  /** Class on the camera trigger, so a host can keep its own styling for it. */
  className?: string;
  title?: string;
}

/**
 * A camera icon that opens the screenshot behind it.
 *
 * Extracted from SourceTypeBadge so the activity table and the per-role evidence list
 * share one viewer rather than each carrying its own modal. Renders nothing without a
 * key, so callers can hand it whatever they have and let it decide.
 */
export function ScreenshotViewer({ screenshotKey, className, title }: ScreenshotViewerProps) {
  const [showScreenshot, setShowScreenshot] = useState(false);

  if (!screenshotKey) return null;

  return (
    <>
      <span
        className={className ?? 'screenshot-viewer__camera'}
        title={title ?? 'View screenshot'}
        onClick={(e) => {
          // Rows can be clickable; opening the screenshot should not also trigger them.
          e.stopPropagation();
          setShowScreenshot(true);
        }}
      >
        <AiOutlineCamera />
      </span>
      <ReactModal
        isOpen={showScreenshot}
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={true}
        onRequestClose={() => setShowScreenshot(false)}
        style={General.getSliderDefaults({ width: 'min(70vw, 1600px)' })}
        closeTimeoutMS={200}
        parentSelector={General.getModalRoot}
      >
        <div className="screenshot-wrapper">
          <Image src={`${CLOUDFRONT_DOMAIN}/${screenshotKey}`} alt="Screenshot" />
        </div>
      </ReactModal>
    </>
  );
}
